module.exports = __webpack_public_path__ + "img/mpp-banner2.8e287477.png";